// Bridges "has the user started their day?" between React (AppContext/TopBar, which
// fetch it via react-query) and the plain axios module in api.js, which can't use hooks.
// `checked` stays false until the first attendance/today response lands, so we never
// block mutations before we actually know the real state (e.g. right after login).
export const dayStatus = { started: false, checked: false };

export function setDayStatus(started) {
  dayStatus.started = started;
  dayStatus.checked = true;
}

export function resetDayStatus() {
  dayStatus.started = false;
  dayStatus.checked = false;
}
